import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeCtx = createContext({ mode: 'light', setMode: () => {}, reducedMotion: false, setReducedMotion: () => {} });

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    if (typeof window === 'undefined') return 'light';
    return localStorage.getItem('kindra-theme') || 'light';
  });
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    if (mode === 'dark') root.classList.add('dark'); else root.classList.remove('dark');
    localStorage.setItem('kindra-theme', mode);
  }, [mode]);

  useEffect(() => {
    const root = document.documentElement;
    if (reducedMotion) root.classList.add('reduce-motion'); else root.classList.remove('reduce-motion');
  }, [reducedMotion]);

  return (
    <ThemeCtx.Provider value={{ mode, setMode, reducedMotion, setReducedMotion }}>
      {children}
    </ThemeCtx.Provider>
  );
};

export const useTheme = () => useContext(ThemeCtx);
